module.exports = __webpack_public_path__ + "static/media/DSC_0016.d4dfb345.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0016.jpg
// module id = 614
// module chunks = 0